import { applyMiddleware, createStore, compose } from 'redux'
import createLogger from 'redux-logger'
import createSagaMiddleware from 'redux-saga'
import { browserHistory } from 'react-router'
import { routerMiddleware } from 'react-router-redux'

import rootReducer from '../reducers'
import mySaga from '../sagas/index'

const sagaMiddleware = createSagaMiddleware()

export default (initialState) => {
  const middleware = [
    routerMiddleware(browserHistory),
    createLogger({ collapsed: true }),
    sagaMiddleware,
  ]

  const store = createStore(
    rootReducer,
    initialState,
    compose(
      applyMiddleware(...middleware),
      window.devToolsExtension ? window.devToolsExtension() : f => f,
    ),
  )

  sagaMiddleware.run(mySaga)

  return store
}



// WEBPACK FOOTER //
// ./src/store/configure-store.js